const addWatchList = provinceDetail => {
  return {
    type: 'ADDWATCHLIST',
    payload: provinceDetail
  }
}

export default addWatchList